import React, { useEffect, useState } from 'react';
import {
    Box,
    TableCell,
    TableRow,
    makeStyles,
    Theme,
    Fade,
    InputBase,
    IconButton,
} from '@material-ui/core';
import { IEditableRow } from './types';
import { Save } from 'react-feather';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { TYPEOF_STRING } from 'src/constants/utils/typeof';

const useStyles = makeStyles((theme: Theme) => ({
    fontWeightMedium: {
        fontWeight: 500,
        backgroundColor: theme.palette.background.paper,
        width: 100,
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
    },
    typography: {
        display: 'inline-block',
    },
    input: {
        color: theme.palette.text.secondary,
        fontSize: 16,
        width: '85%',
    },
    save: {
        marginLeft: 10,
        padding: 8,
    },
}));

export const EditableRow = ({
    item,
    loading,
    handleSave,
    ...props
}: IEditableRow) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [text, setText] = useState<string>('');
    const { enqueueSnackbar } = useSnackbar();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
        setText(event.target.value);

    useEffect(() => {
        if (typeof item.text === TYPEOF_STRING) setText(String(item.text));
    }, [item.text]);

    const handleValidate = (value: string) => {
        if (item.validate) return item.validate(value);
        return true;
    };

    const handleSubmit = () => {
        if (item.field) {
            if (handleValidate(text)) handleSave({ [item.field]: text });
            else
                enqueueSnackbar(t('SnackBar.ValidValue'), {
                    variant: 'error',
                });
        }
    };

    return (
        <TableRow {...props}>
            <TableCell className={classes.fontWeightMedium}>
                {item.header}
            </TableCell>
            <Fade in={!loading} timeout={600}>
                <TableCell className={classes.paper}>
                    <Box display="flex" alignItems="center">
                        <InputBase
                            value={text}
                            inputComponent={item.mask}
                            inputProps={{
                                'aria-label': 'naked',
                            }}
                            className={classes.input}
                            onChange={handleChange}
                        />

                        <IconButton className={classes.save}>
                            <Save
                                size={20}
                                onClick={() => item.field && handleSubmit()}
                            />
                        </IconButton>
                    </Box>
                </TableCell>
            </Fade>
        </TableRow>
    );
};
